module.exports = __webpack_public_path__ + "static/media/power.3f19aa87.svg";